import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminAction } from 'src/app/models/adminaction.model';
import { Collections } from 'src/app/models/collections/collectionsModel';
import { SchoolModuleBatch } from 'src/app/models/module/moduledetails';
import { CollectionsService } from 'src/app/services/collections/collections.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { DetectlocationService } from 'src/app/services/detectlocation.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { PaymentService } from 'src/app/services/payment.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-collectiondetails',
  templateUrl: './collectiondetails.component.html',
  styleUrls: ['./collectiondetails.component.css']
})
export class CollectiondetailsComponent implements OnInit {
  currency: string;
  collectionData: Collections[] = [];
  filteredCollectionData: Collections[] = [];
  total = 0;
  count = 0;
  searchText: string = "";
  sortAsc = false;
  sortBy: string = "";
  Pages = [20,40,60,80,100];
  perPage = 20;
  offset = 0;
  currentPage = 1;
  numberButtons = []
  toDate:any="";
  fromDate:any = "";
  moduleBatches: SchoolModuleBatch[] = [];
  batchFilterActions: AdminAction[] = [];
  moduleFilterActions: AdminAction[] = [];
  modules: any;
  activeModuleFilterId: number = 0;
  activeBatchFilterId: number = 0;
  allowBatches = false;

  constructor(private collectionService: CollectionsService, public util: UtilService, private headerInfo: ComponentheaderService, public modulemanager: ModulemanagementService,
    public schoolservice: SchoolmanagementService, private toastr: ToastrService, private locationService: DetectlocationService,) {
  }
  async ngOnInit() {
    this.currency = await this.locationService.getCurrencyString();
    const school: any = await this.util.getStaticSchoolInfoBundle();
    this.modules = await this.modulemanager.getAllSchoolModule(school.schoolInfo.id).toPromise();    
    if (this.modules.length > 0){
      this.createModuleDropdownActions();
    }         
    
    this.headerInfo.setHeaderDisplay('Loading...', [], []);
    await this.LoadCollection();
    this.headerInfo.setHeaderDisplay('Collections', [
      { displaytext: "School", route: `/user/schoolhome` },
      { displaytext: "Collections", route: `/collection/collections`}
    ], []);    
  }

  createModuleDropdownActions(){
    let allModulesAction = new AdminAction();
      allModulesAction.displaytext = "All Modules";
      allModulesAction.params = {id: 0};
      this.moduleFilterActions.push(allModulesAction);
      this.modules.forEach(b => {
        let obj = new AdminAction();
        obj.displaytext = b.moduleName;
        obj.params = {id: b.id};
        obj.callback = (id: number) => this.filterByModuleAction(id);
        if (!this.moduleFilterActions.find(a => a.displaytext == b.moduleName))
          this.moduleFilterActions.push(obj);
      });
  }

  async filterByModuleAction(id: number){
    this.activeModuleFilterId = id;
    this.activeBatchFilterId = 0;
    
    this.allowBatches = this.modules.find(m => m.id == id).allowBatches;
    this.moduleBatches = await this.modulemanager.getModuleBatches(id).toPromise();
    this.batchFilterActions = [];
    let defaultBatchAction = new AdminAction();
    defaultBatchAction.displaytext = "All Batches";
    defaultBatchAction.params = {id: 0};
    this.batchFilterActions.push(defaultBatchAction);
    this.moduleBatches.forEach(b => {
      let obj = new AdminAction();
      obj.displaytext = b.name;
      obj.params = {id: b.id};
      if (!this.batchFilterActions.find(a => a.displaytext == b.name))
        this.batchFilterActions.push(obj);
    });        
  }

  filterByBatch(id: number){
    this.activeBatchFilterId = id;    
  }

  async LoadCollection() {
    try {
      this.headerInfo.pageLoadingStarted(this);
      // load search collections
      await this.collectionService.getSortPerPageCollections(this.searchText, this.sortBy,
        this.sortAsc, this.offset, this.perPage,this.toDate,this.fromDate, this.activeModuleFilterId, this.activeBatchFilterId).toPromise().then((res: any) => {
          this.collectionData = res;
          if (this.collectionData.length > 0) {
            this.count = this.collectionData[0].count;
            this.total = this.collectionData[0].total;
            this.loadButtons();
          }
        });
    }
    finally {

      this.headerInfo.pageLoadingDone(this);
    }
  }

  async changeSort(sort: string) {

    if (sort == this.sortBy) {
      this.sortAsc = !this.sortAsc;
    } else {
      this.sortAsc = true;
    }
    this.sortBy = sort;
    await this.LoadCollection();
  }

  async changePerpage(event: any) {
    await this.getPageData(1);
    this.loadButtons();
  }

  loadButtons() {
    const totalPages = Math.ceil(this.count / this.perPage);
    this.numberButtons = Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  async getPageData(pageNo) {
    this.offset = (pageNo - 1) * this.perPage
    await this.LoadCollection();
    this.currentPage = pageNo;
  }

  getButtonColor(pageNo) {
    if (pageNo === this.currentPage) {
      return { 'background-color': '#04796a',color:'#fff'};
    }
    else {
      return {};
    }
  }

}
